(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ek-faq"] && !Shopify.designMode) return;
  try {
    
/* ---------------------------------------------------------------------------
   EK · FAQ — accordion behaviour (self-contained, delegated, idempotent).
   Delegation means it also covers sections re-rendered by the theme editor.
--------------------------------------------------------------------------- */
(function () {
  if (window.__ekFaqInit) return;
  window.__ekFaqInit = true;

  function itemOf(el) { return el.closest('.ek-faq__item'); }

  function setOpen(item, open) {
    if (!item) return;
    var btn = item.querySelector('.ek-faq__btn');
    item.classList.toggle('is-open', open);
    if (btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('.ek-faq__btn') : null;
    if (!btn) return;
    var item = itemOf(btn);
    if (!item) return;

    var section = btn.closest('[data-ek-faq]');
    var open = !item.classList.contains('is-open');

    if (open && section && section.getAttribute('data-ek-faq-single') === 'true') {
      section.querySelectorAll('.ek-faq__item.is-open').forEach(function (other) {
        if (other !== item) setOpen(other, false);
      });
    }
    setOpen(item, open);
  });

  function init(root) {
    (root || document).querySelectorAll('[data-ek-faq]').forEach(function (section) {
      if (section.dataset.ekFaqReady) return;
      section.dataset.ekFaqReady = '1';

      /* Reveal failsafe — if ek-custom.js is absent, .ek-reveal would leave the
         whole section at opacity:0 and it would look "broken"/blank. */
      if (!window.__ekInit) {
        section.querySelectorAll('.ek-reveal').forEach(function (el) { el.classList.add('is-in'); });
      }

      if (section.getAttribute('data-ek-faq-first-open') === 'true') {
        setOpen(section.querySelector('.ek-faq__item'), true);
      }
    });
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', function () { init(); });

  /* Theme editor: re-init on section load, and open the block being edited. */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var item = e.target.classList && e.target.classList.contains('ek-faq__item')
      ? e.target : (e.target.querySelector ? e.target.querySelector('.ek-faq__item') : null);
    if (item) setOpen(item, true);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ek-indication-detail"] && !Shopify.designMode) return;
  try {
    
/* Accordion behaviour for the metafield-driven treatment menu. Block-driven
   rows keep their own handler in blocks/modality.liquid; this script only ever
   binds inside [data-ek-acc], so the two never fight over the same node. */
(function () {
  function bind(root) {
    if (root.dataset.ekAccBound === '1') return;
    root.dataset.ekAccBound = '1';
    root.addEventListener('click', function (e) {
      var btn = e.target.closest('.ek-detail__ibtn');
      if (!btn || !root.contains(btn)) return;
      var item = btn.closest('.ek-detail__item');
      if (!item) return;
      var open = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', open ? 'false' : 'true');
      item.classList.toggle('is-open', !open);
    });
  }
  function init() {
    document.querySelectorAll('[data-ek-acc]').forEach(bind);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ek-programme-detail"] && !Shopify.designMode) return;
  try {
    
/* Accordion. Scoped to [data-ek-acc] so it cannot bind twice or reach another
   section's rows. Shares the behaviour of the indication treatment menu. */
(function () {
  function bind(root) {
    if (root.dataset.ekAccBound === '1') return;
    root.dataset.ekAccBound = '1';
    root.addEventListener('click', function (e) {
      var btn = e.target.closest('.ek-prog__ibtn');
      if (!btn || !root.contains(btn)) return;
      var item = btn.closest('.ek-prog__item');
      if (!item) return;
      var open = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', open ? 'false' : 'true');
      item.classList.toggle('is-open', !open);
    });
  }
  function init() { document.querySelectorAll('[data-ek-acc]').forEach(bind); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ek-typeform"] && !Shopify.designMode) return;
  try {
    
/* ---------------------------------------------------------------------------
   EK · Typeform — loads embed.typeform.com once, and re-scans the page when
   the theme editor re-renders a section (otherwise the embed shows blank
   until you reload the preview).
--------------------------------------------------------------------------- */
(function () {
  var SRC = 'https://embed.typeform.com/next/embed.js';

  function rescan() {
    if (window.tf && typeof window.tf.load === 'function') window.tf.load();
  }

  function ensureScript() {
    if (document.querySelector('script[src="' + SRC + '"]')) { rescan(); return; }
    var el = document.createElement('script');
    el.src = SRC;
    el.async = true;
    document.head.appendChild(el);
  }

  if (document.readyState !== 'loading') ensureScript();
  else document.addEventListener('DOMContentLoaded', ensureScript);

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('[data-tf-live]')) {
      ensureScript();
      setTimeout(rescan, 60);
    }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
